module.exports = __webpack_public_path__ + "static/media/browsers.9df2a72f.jpg";